import { Fragment, FunctionComponent } from "react";
import * as sentry from "@sentry/react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { showServerError } from "utilities/show-server-error";
import { Toaster } from "react-hot-toast";
import { IProps } from "./application.types";
import { shouldRequestRetry } from "@edgetier/utilities";
import "./application.scss";
import ErrorFallback from "components-for/errors/error-fallback";
import { getRouterSetup } from "utilities-for/routes/get-router-setup";
import setDefaultOptions from "date-fns/setDefaultOptions";

setDefaultOptions({ weekStartsOn: 1 });

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            onError: showServerError,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: shouldRequestRetry,
        },
    },
});
const router = createBrowserRouter(getRouterSetup());

const Application: FunctionComponent<IProps> = () => {
    return (
        <Fragment>
            <Toaster position="bottom-right" toastOptions={{ style: { backgroundColor: "#34495e", color: "white" } }} />

            <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools
                    initialIsOpen={false}
                    position="top-left"
                    toggleButtonProps={{ className: "react-query-devtools__button" }}
                />
                <RouterProvider router={router} />
            </QueryClientProvider>
        </Fragment>
    );
};

export default sentry.withErrorBoundary(Application, {
    fallback: ErrorFallback,
    showDialog: true,
});
